// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/plugins/Phone

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function Phone(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'Phone',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      d: 'M3.192 6.634l1.799 2.027a12.586 12.586 0 002.025-1.645 12.5 12.5 0 001.645-2.025L6.634 3.192 8.124 0 12 1.66a12.477 12.477 0 01-3.507 6.833A12.477 12.477 0 011.66 12L0 8.124l3.192-1.49z',
      fill: 'currentColor',
    })
  );
}
